module.exports = __webpack_public_path__ + "static/media/loading_doc.9c1aa39a.gif";